import request from "@/service";

//可报名班级分页列表
export function getTeachingContentPage(params) {
  return request({
    url: `/study/class/teachingContent/page`,
    method: "get",
    params
  });
}

/* 设置/取消必修 */
export function setRequired(params) {
  return request({
    url: `/study/class/teachingContent/require`,
    method: "put",
    data: params
  });
}

/* 移除班级教学内容表信息 */
export function removeTeachingContent(params) {
  return request({
    url: `/study/class/teachingContent/delete`,
    method: "delete",
    data: params
  });
}

// 拖拽排序-视频
export function updateVideoByDrag(data) {
  return request({
    url: `/study/class/teachingContent/updateOrderByDrag`,
    method: "put",
    data
  });
}

/* 查询已有教学内容 */
export function getTeachingContentVideo(classId) {
  return request({
    url: `/study/class/teachingContent/getTeachingContentVideo/${classId}`,
    method: "get"
  });
}

/* 查询已有教学内容 */
export function getTeachingContentBook(classId) {
  return request({
    url: `/study/class/teachingContent/getTeachingContentBook/${classId}`,
    method: "get"
  });
}

/* 保存教学内容 */
export function saveTeachingContent(params) {
  return request({
    url: `/study/class/teachingContent/save`,
    method: "post",
    data: params
  });
}
// 教学管理-资源学时
export function getTeachingResourceScore(params) {
  return request({
    url: `/study/class/teachingContent/getTotalScore`,
    method: "get",
    params
  });
}

//  